export enum Localization {
  Uzbekistan = 'uz',
  Europe = 'eu',
}
